import { safeDefine } from "../../registration/safe-define.js";
import { PiPButtonElement } from "../../ui/pip-button/element.js";
//#region src/define/ui/pip-button.ts
safeDefine(PiPButtonElement);
//#endregion

//# sourceMappingURL=pip-button.js.map